/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface FlatPageUpdateInput { 
    archived?: boolean;
    browserTitle?: string;
    content?: string;
    createdAt?: string;
    date?: string;
    heroImage?: string;
    id?: string;
    itemUrl?: string;
    locked?: boolean;
    metaDescription?: string;
    metaKeywords?: string;
    published?: boolean;
    readOnly?: boolean;
    subtitle?: string;
    title: string;
    updatedAt?: string;
    version?: number;
}
